import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as n, createElementVNode as l } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconMic",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ l("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.586 1.086A2 2 0 0 1 8 2.5V6a2 2 0 1 1-4 0V2.5a2 2 0 0 1 .586-1.414ZM6 1.5a1 1 0 0 0-1 1V6a1 1 0 0 0 2 0V2.5a1 1 0 0 0-1-1Zm-3.5 3A.5.5 0 0 1 3 5v1a3 3 0 1 0 6 0V5a.5.5 0 0 1 1 0v1a4 4 0 0 1-3.5 3.969V11H8a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h1.5V9.969A4 4 0 0 1 2 6V5a.5.5 0 0 1 .5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function u(e, f, i, h, p, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--mic"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Mic",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, c);
}
const g = /* @__PURE__ */ o(s, [["render", u]]);
export {
  g as default
};
//# sourceMappingURL=mic.js.map
